package com.devi3east.bashbuddy.features.common.data.database

import com.devi3east.bashbuddy.Recipe
import com.devi3east.bashbuddy.features.common.data.domain.entities.RecipeItem

fun recipeEntityMapper(recipe: Recipe)  = RecipeItem(
    recipe.id,
    recipe.title,
    recipe.description,
    recipe.category,
    recipe.area,
    recipe.imageUrl,
    recipe.youtubeLink,
    recipe.ingredients,
    recipe.instructions,
    recipe.isFavorite == 1L,
    recipe.rating,
    recipe.duration ?: "20 Mins",
    recipe.difficulty ?: "Easy"
)